const dns_select_template_dialog = {
	autocomplete: {
		label: "DNS template",
	},
	description:
		"Selecteer hier een bestaande DNS template waarvan u DNS-records wilt gebruiken. De geselecteerde DNS-records worden toegevoegd aan de huidige DNS-records lijst. De DNS-records die nu in de template staan worden dus niet overschreven door de geselecteerde DNS-records",
	submit_button: {
		label: "Toevoegen ({{record_selected_count}} records)",
	},
	success_message: "De DNS templates zijn succesvol toegevoegd.",
	title: "DNS-template selecteren",
};

export default dns_select_template_dialog;
